import { render, staticRenderFns } from "./LocalChanger.vue?vue&type=template&id=4895e714"
import script from "./LocalChanger.vue?vue&type=script&lang=js"
export * from "./LocalChanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports